// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3HbAF","header":"MessagesList_header__21FU_","chat":"MessagesList_chat__pyrFI"};